import { BANNER_HEIGHT, SHOW_MORE_MAX_LINES } from './constants';
export function isCookieBannerEmpty(props) {
    return !props.text;
}
export const getBannerHeight = ({ isInfiniteDesktopView, isTabletView, isShowMoreExpanded, }) => {
    if (isInfiniteDesktopView) {
        return isShowMoreExpanded ? BANNER_HEIGHT.desktop.expanded : BANNER_HEIGHT.desktop.collapsed;
    }
    if (isTabletView) {
        return isShowMoreExpanded ? BANNER_HEIGHT.tablet.expanded : BANNER_HEIGHT.tablet.collapsed;
    }
    return isShowMoreExpanded ? BANNER_HEIGHT.mobile.expanded : BANNER_HEIGHT.mobile.collapsed;
};
export const getVisibleRows = ({ isInfiniteDesktopView, isTabletView }) => {
    if (isInfiniteDesktopView) {
        return SHOW_MORE_MAX_LINES.desktop;
    }
    if (isTabletView) {
        return SHOW_MORE_MAX_LINES.tablet;
    }
    return SHOW_MORE_MAX_LINES.mobile;
};
